import Vue from 'vue'
import Router from 'vue-router'
import { Auth } from 'aws-amplify'

Vue.use(Router)

const routes = [
  {
    path: '/order',
    name: '受発注管理',
    component: () => import('../views/Wrap'),
    meta: {
      requiresAuth: true,
      icon: '',
      bashboard: true,
    },
    children: [
      {
        path: '/projects',
        name: 'プロジェクト',
        component: () => import('../views/Projects'),
        meta: {
          requiresAuth: true,
          requiresAdmin: false,
          icon: require('@/assets/project.png'),
        },
        children: [
          {
            path: '/project/:id',
            name: 'プロジェクト詳細',
            component: () => import('../views/ProjectDetail'),
            meta: {
              requiresAuth: true,
              requiresAdmin: false,
            },
          },
        ],
      },
      {
        path: '/order-lists',
        name: '見積・請求',
        component: () => import('../views/OrderLists'),
        meta: {
          requiresAuth: true,
          requiresAdmin: false,
          icon: require('@/assets/orderLists.png'),
        }
      },
      {
        path: '/payment-lists',
        name: '発注・支払',
        component: () => import('../views/PaymentLists'),
        meta: {
          requiresAuth: true,
          requiresAdmin: false,
          icon: require('@/assets/paymentLists.png'),
        }
      },
    ],
  },
  {
    path: '/report',
    name: '報告書管理',
    component: () => import('../views/Wrap'),
    meta: {
      requiresAuth: true,
      icon: '',
      bashboard: true,
    },
    children: [
      {
        path: '/dialy',
        name: '日報',
        component: () => import('../views/Dialy'),
        meta: {
          requiresAuth: true,
          requiresAdmin: false,
          icon: require('@/assets/dialy.png'),
        },
      },
      {
        path: '/summary',
        name: '日報集計',
        component: () => import('../views/Summary'),
        meta: {
          requiresAuth: true,
          requiresAdmin: false,
          icon: require('@/assets/summary.png'),
        },
      },
      {
        path: '/overtime',
        name: '残業集計',
        component: () => import('../views/OverTime'),
        meta: {
          requiresAuth: true,
          requiresAdmin: false,
          icon: require('@/assets/overtime.png'),
        },
      },
    ],
  },
  {
    path: '/product',
    name: '商品管理',
    component: () => import('../views/Wrap'),
    meta: {
      requiresAuth: true,
      icon: '',
      bashboard: true,
    },
    children: [
      {
        path: '/products',
        name: '商品',
        component: () => import('../views/Products'),
        meta: {
          requiresAuth: true,
          requiresAdmin: false,
          icon: require('@/assets/product.png'),
        }
      },
      {
        path: '/customer-models',
        name: '客先向け商品',
        component: () => import('../views/CustomerModels'),
        meta: {
          requiresAuth: true,
          requiresAdmin: false,
          icon: require('@/assets/customerModel.png'),
        }
      },
      {
        path: '/stock',
        name: '在庫',
        component: () => import('../views/Stock'),
        meta: {
          requiresAuth: true,
          requiresAdmin: false,
          icon: require('@/assets/stock.png'),
        }
      },
    ],
  },
  {
    path: '/reserve',
    name: '予約管理',
    component: () => import('../views/Wrap'),
    meta: {
      requiresAuth: true,
      icon: '',
      bashboard: true,
    },
    children: [
      {
        path: '/facility-reserve',
        name: '施設予約',
        component: () => import('../views/FacilityReserve'),
        meta: {
          requiresAuth: true,
          requiresAdmin: false,
          icon: require('@/assets/facility-reserve.png'),
        },
      },
    ],
  },
  {
    path: '/data',
    name: 'データ管理',
    component: () => import('../views/Wrap'),
    meta: {
      requiresAuth: true,
      icon: '',
      bashboard: true,
    },
    children: [
      {
        path: '/customers',
        name: '客先',
        component: () => import('../views/Customers'),
        meta: {
          requiresAuth: true,
          requiresAdmin: false,
          icon: require('@/assets/customer.png'),
        }
      },
      {
        path: '/worktype',
        name: '作業種別',
        component: () => import('../views/WorkType'),
        meta: {
          requiresAuth: true,
          requiresAdmin: false,
          icon: require('@/assets/worktype.png'),
        }
      },
      {
        path: '/worktime',
        name: '労務・休憩時間',
        component: () => import('../views/WorkTime'),
        meta: {
          requiresAuth: true,
          requiresAdmin: false,
          icon: require('@/assets/worktime.png'),
        }
      },
      {
        path: '/events',
        name: '休日・イベント',
        component: () => import('../views/Events'),
        meta: {
          requiresAuth: true,
          requiresAdmin: false,
          icon: require('@/assets/calendar.png'),
        }
      },
      {
        path: '/facility',
        name: '施設',
        component: () => import('../views/Facility'),
        meta: {
          requiresAuth: true,
          requiresAdmin: false,
          icon: require('@/assets/facility.png'),
        }
      },
      {
        path: '/automobile',
        name: '車両',
        component: () => import('../views/Automobile'),
        meta: {
          requiresAuth: true,
          requiresAdmin: false,
          icon: require('@/assets/automobile.png'),
        }
      },
    ],
  },
  {
    path: '/settings',
    name: '設定',
    component: () => import('../views/Wrap'),
    meta: {
      requiresAuth: true,
      icon: '',
      bashboard: true,
    },
    children: [
      {
        path: '/users',
        name: 'アカウント',
        component: () => import('../views/Users'),
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
          icon: require('@/assets/account.png'),
        }
      },
      {
        path: '/roles',
        name: '権限',
        component: () => import('../views/Roles'),
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
          icon: require('@/assets/key.png'),
        }
      },
      {
        path: '/app-setting',
        name: 'アプリ設定',
        component: () => import('../views/appSetting'),
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
          icon: require('@/assets/appSetting.png'),
        }
      },
      {
        path: '/company-setting',
        name: '企業情報',
        component: () => import('../views/companySetting'),
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
          icon: require('@/assets/companySetting.png'),
        }
      },
      {
        path: '/logs',
        name: 'ログ',
        component: () => import('../views/Logs'),
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
          icon: require('@/assets/logs.png'),
        }
      },
    ],
  },
  {
    path: '/',
    name: 'ダッシュボード',
    component: () => import('../views/DashBoard'),
    meta: {
      requiresAuth: true,
      icon: '',
      bashboard: false,
    }
  },
  {
    path: '/login',
    name: 'ログイン',
    component: () => import('../views/Login'),
    meta: {
      requiresAuth: false,
      icon: '',
      bashboard: false,
    }
  },
  {
    path: '/forgot',
    name: 'パスワードを忘れた方',
    component: () => import('../views/Forgot'),
    meta: {
      requiresAuth: false,
      icon: '',
      bashboard: false,
    }
  },
]

const router = new Router({
  base: process.env.BASE_URL,
  routes: routes
})

router.beforeEach(async (to, from, next) => {
  try {
    //ログインが必要か
    let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    //ログインチェック
    if (requiresAuth) {
      const user = await Auth.currentAuthenticatedUser()
      if (user) {
        next()
      } else {
        throw 'ログインしていない'
      }
    } else {
      next()
    }
  } catch (error) {
    //console.log(error)
    next({
      path: '/login',
      query: {
        redirect: to.fullPath
      }
    })
  }
})

export default router
